import { useEffect, useState } from "react";
import api from "../../services/api";
import { II } from "../../components/common/Icons";
import { R } from "../../utils/helpers";
import T from "../../assets/styles/theme";import "../../assets/styles/PM/PMAdvancesPg.css";

function PMAdvancesPg() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  const load = async () => {
    try {
      setLoading(true);
      const data = await api.getAdvances();
      setRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setMsg("Failed to load advances: " + e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const takeAction = async (id, action) => {
    try {
      await api.advanceAction(id, action);
      setRows((prev) => prev.filter((r) => r.id !== id));
      setMsg(`Advance ${id} ${action === "approved" ? "approved" : "rejected"} by manager.`);
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      setMsg("Action failed: " + e.message);
    }
  };

  return (
    <div>
      <div className="pmadvancespg-inline-1">
        <div className="sec pmadvancespg-inline-2">Salary Advances</div>
        <button className="btn-o btn-s" onClick={load}>{loading ? "..." : "Refresh"}</button>
      </div>

      {msg ? <div className="toast">{II("chk", 16, { c: "#2563eb" })} {msg}</div> : null}

      <div className="cd">
        <div className="cd-h">
          <div className="cd-t">Pending Manager Approval</div>
          <div className="cd-s">{rows.length} requests</div>
        </div>
        <div className="cd-b pmadvancespg-inline-3">
          <table className="tbl">
            <thead>
              <tr>
                <th>ID</th>
                <th>Employee</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Months</th>
                <th>Reason</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ?
              <tr><td colSpan="7" style={{ "--pmadvancespg-1-color": T.textMuted }} className="pmadvancespg-dyn-1">Loading...</td></tr> :
              rows.length === 0 ?
              <tr><td colSpan="7" style={{ "--pmadvancespg-2-color": T.textMuted }} className="pmadvancespg-dyn-2">No pending advances.</td></tr> :
              rows.map((r) =>
              <tr key={r.id}>
                  <td className="pmadvancespg-inline-4">{r.id}</td>
                  <td className="pmadvancespg-inline-5">{r.emp || r.emp_name}</td>
                  <td>{R}{r.amt || r.amount}</td>
                  <td>{r.type || "Full"}</td>
                  <td>{r.months || 1}</td>
                  <td className="pmadvancespg-inline-6">{r.reason || "-"}</td>
                  <td>
                    <div className="pmadvancespg-inline-7">
                      <button className="btn btn-s btn-ok" onClick={() => takeAction(r.id, "approved")}>{II("chk", 12)} Approve</button>
                      <button className="btn btn-s btn-dn" onClick={() => takeAction(r.id, "rejected")}>{II("x", 12)} Reject</button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>);

}

export default PMAdvancesPg;